import Vue from 'vue'
import moment from 'moment'

const state = () => ({
  guides: {}
})

const mutations = {
  'ADD_GUIDES': (state, payload) => {
    for (let i = 0; i < Object.keys(payload).length; i++) {
      let key = Object.keys(payload)[i]
      Vue.set(state.guides, key, payload[key])
    }
  }
}

const actions = {
  addGuides ({commit}, payload) {
    commit('ADD_GUIDES', payload)
  }
}

const getters = {
  getTftGuides: state => {
    return Object.values(state.guides).filter((guide) => {
      if (guide.publish_date && guide.publish_date > moment()) {
        return false
      }
      return guide.game === 'teamfight-tactics'
    }).sort((a, b) => {
      if (!a.publish_date) {
        return 1
      } else if (!b.publish_date) {
        return -1
      } else if (a.publish_date < b.publish_date) {
        return 1
      } else if (a.publish_date > b.publish_date) {
        return -1
      } else {
        return 0
      }
    }).reduce((result, guide) => {
      result[guide.slug] = guide
      return result
    }, {})
  },
  getWowGuides: state => {
    return Object.values(state.guides).filter((guide) => {
      if (guide.publish_date && guide.publish_date > moment()) {
        return false
      }
      return guide.game === 'world-of-warcraft'
    }).sort((a, b) => {
      if (!a.publish_date) {
        return 1
      } else if (!b.publish_date) {
        return -1
      } else if (a.publish_date < b.publish_date) {
        return 1
      } else if (a.publish_date > b.publish_date) {
        return -1
      } else {
        return 0
      }
    }).reduce((result, guide) => {
      result[guide.slug] = guide
      return result
    }, {})
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/guides.js